import InstrumentTypeFilter from './InstrumentTypeFilter';

export default InstrumentTypeFilter